export default __webpack_public_path__ + "static/media/dsv-amazon-prime.2ff41460.svg";